import {Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartData} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {Bar} from 'react-chartjs-2';

import {Grid, Typography} from '@mui/material';

import {getBarGraphOptions} from './graphConfig';
import {DoubleArrow} from '../../../../../../../assets/icons';
import {EmpionPaper} from '../../../../../../../components/EmpionPaper/EmpionPaper';
import {greenColors} from '../../../../../../../layouts/theme/designSystem';

interface Props {
  title: string;
  leftLabel: string;
  rightLabel: string;
  chartData: ChartData<'bar'>;
  isPdf?: boolean;
}

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

export const DreamEmployerGraph = ({title, leftLabel, rightLabel, chartData, isPdf}: Props) => {
  const options = getBarGraphOptions(title, isPdf);

  return (
    <EmpionPaper sx={{mb: 6, backgroundColor: 'white', padding: '8px'}}>
      <Bar options={options} data={chartData} data-testid='bar-graph' />
      <Grid container marginLeft={1}>
        <Grid item xs={4} sx={{textAlign: 'center'}}>
          <Typography variant='body2' marginLeft={2} sx={{color: greenColors[700]}}>
            (1-2)
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{textAlign: 'center'}}>
          <Typography variant='body2' sx={{color: greenColors[700]}}>
            (3-4)
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{textAlign: 'center'}}>
          <Typography variant='body2' marginRight={1} sx={{color: greenColors[700]}}>
            (5-6)
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent={'center'}
        alignItems={'center'}
        minHeight={'40px'}
        sx={{marginTop: isPdf ? '0' : '8px'}}
      >
        <Grid item xs={4}>
          <Typography
            sx={{
              marginRight: '12px',
              lineHeight: isPdf ? 1 : '23px',
              fontSize: isPdf ? '12px' : '16px',
              color: greenColors[700],
            }}
          >
            {leftLabel}
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{display: 'flex', justifyContent: 'center'}}>
          <DoubleArrow style={{color: greenColors[700]}} />
        </Grid>
        <Grid item xs={4}>
          <Typography
            textAlign={'right'}
            sx={{
              marginLeft: '12px',
              lineHeight: isPdf ? 1 : '23px',
              fontSize: isPdf ? '12px' : '16px',
              color: greenColors[700],
            }}
          >
            {rightLabel}
          </Typography>
        </Grid>
      </Grid>
    </EmpionPaper>
  );
};
